"use strict";
import React from "react";

const initComponent = (flex = window.flex) => {

    class Ping extends React.Component {
        ping = () => {
            flex.log("pinging from ping");
            flex.ping({
                error: function () {
                    alert("still unable to connect...");
                }
            });
        };

        render() {
            return (
                <div style={{ backgroundColor: "#f3f3f4", width: "100%", height: "100%", position: "fixed", top: "0", left: "0", zIndex: "99999" }}>
                    <div style={{ width: "300px", margin: "40px auto" }}>
                        <h1>Connectivity Issues...</h1>
                        <button className="btn" onClick={this.ping}>Try to Connect</button>
                    </div>
                </div>
            );
        }
    };

    return Ping;
};

module.exports = initComponent;
